import { defineStore } from "pinia";
import { ref } from "vue";
import { logger } from "@/infrastructure/services/LoggerService";
import { getOrganisationAddresses, createAddress as createAddressService, updateAddress as updateAddressService, deleteAddress as deleteAddressService, setPrimaryAddress as setPrimaryAddressService, } from "../infrastructure/adapters/organisationService";
export const useOrganisationStore = defineStore("organisation", () => {
    const addresses = ref([]);
    async function loadAddresses(id) {
        if (!id)
            return;
        try {
            const response = await getOrganisationAddresses(id);
            const result = response.result;
            if (result.length > 0 && !result.some((a) => a.isPrimary)) {
                const last = result.length - 1;
                result[last] = { ...result[last], isPrimary: true };
            }
            addresses.value = result;
        }
        catch (err) {
            logger.error("[useOrganisationStore] loadAddresses failed:", err);
        }
    }
    async function addAddress(organisationId, address) {
        addresses.value.push(address);
        try {
            const createdId = await createAddressService(organisationId, address);
            const idx = addresses.value.findIndex((a) => a.id === address.id);
            if (idx !== -1)
                addresses.value[idx] = { ...address, id: createdId };
        }
        catch (err) {
            const idx = addresses.value.findIndex((a) => a.id === address.id);
            if (idx !== -1)
                addresses.value.splice(idx, 1);
            logger.error("[useOrganisationStore] addAddress failed:", err);
            throw err;
        }
    }
    async function editAddress(organisationId, address) {
        const idx = addresses.value.findIndex((a) => a.id === address.id);
        const previous = idx !== -1 ? { ...addresses.value[idx] } : null;
        if (idx !== -1)
            addresses.value[idx] = address;
        try {
            await updateAddressService(organisationId, address);
        }
        catch (err) {
            if (idx !== -1 && previous)
                addresses.value[idx] = previous;
            logger.error("[useOrganisationStore] editAddress failed:", err);
            throw err;
        }
    }
    async function removeAddress(organisationId, addressId) {
        try {
            await deleteAddressService(organisationId, addressId);
            const idx = addresses.value.findIndex((a) => a.id === addressId);
            if (idx !== -1) {
                const wasPrimary = addresses.value[idx].isPrimary;
                addresses.value.splice(idx, 1);
                if (wasPrimary && addresses.value.length > 0) {
                    addresses.value[addresses.value.length - 1].isPrimary = true;
                }
            }
        }
        catch (err) {
            logger.error("[useOrganisationStore] removeAddress failed:", err);
            throw err;
        }
    }
    async function setPrimaryAddress(organisationId, id) {
        const previous = addresses.value.map((a) => ({ id: a.id, isPrimary: a.isPrimary }));
        addresses.value.forEach((a) => {
            a.isPrimary = a.id === id;
        });
        try {
            await setPrimaryAddressService(organisationId, id);
        }
        catch (err) {
            addresses.value.forEach((a) => {
                const prev = previous.find((p) => p.id === a.id);
                if (prev)
                    a.isPrimary = prev.isPrimary;
            });
            logger.error("[useOrganisationStore] setPrimaryAddress failed:", err);
            throw err;
        }
    }
    function clearAddresses() {
        addresses.value = [];
    }
    return {
        addresses,
        loadAddresses,
        addAddress,
        editAddress,
        removeAddress,
        setPrimaryAddress,
        clearAddresses,
    };
});
